import { combineReducers } from "redux";

import client from "./client";
import deliveryPoints from "./deliveryPoints";
import contact from "./contact";
import service from "./services"
import driver from "./driver";
import transport from "./transport";
import transportBrand from "./transportBrand";
import transportSupplier from "./transportSupplier";
import operators from "./operators";
import zone from "./zone";
import invoice from "./invoice";
import fuel from "./fuel";
import provider from "./provider";
import costProvider from "./costProvider";
import costGlobal from "./costGlobal";
import fileDriver from "./filesDriver";
import fileTransport from "./filesTransport";
import fileProvider from "./filesProvider";

export default combineReducers({
  client,
  deliveryPoints,
  contact,
  service,
  driver,
  transport,
  transportBrand,
  transportSupplier,
  operators,
  zone,
  invoice,
  provider,
  costProvider,
  costGlobal,
  fuel,
  fileDriver,
  fileTransport,
  fileProvider
});
